export { default } from './InvitationAccept';
